import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

interface Alert {
  type: 'success' | 'error' | 'warning' | 'info';
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  private alertSubject = new BehaviorSubject<Alert | null>(null);
  alert$ = this.alertSubject.asObservable();

  showAlert(type: Alert['type'], message: string) {
    this.alertSubject.next({ type, message });

    setTimeout(() => this.clearAlert(), 5000); // Auto-dismiss after 5 sec
  }

  clearAlert() {
    this.alertSubject.next(null);
  }
}
